"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDateRange = require("react-date-range");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

require("moment/locale/ca");

var _dateFns = require("date-fns");

var _locale = require("react-date-range/dist/locale");

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _request = require("../../common/request");

var _request2 = _interopRequireDefault(_request);

var _PanelSelectRangTemporal = require("./PanelSelectRangTemporal.css");

var _PanelSelectRangTemporal2 = _interopRequireDefault(_PanelSelectRangTemporal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//     

/* import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css"; */

var PanelSelectRangTemporal = function (_Component) {
	_inherits(PanelSelectRangTemporal, _Component);

	function PanelSelectRangTemporal(props) {
		_classCallCheck(this, PanelSelectRangTemporal);

		var _this = _possibleConstructorReturn(this, (PanelSelectRangTemporal.__proto__ || Object.getPrototypeOf(PanelSelectRangTemporal)).call(this, props));

		_this.getInitEndDate = function (timemax, singledays, dynamic) {
			return singledays && dynamic ? new Date() : new Date(timemax);
		};

		_this.isDiaActual = function (timemax) {
			return (0, _moment2.default)(timemax).format("YYYY-MM-DD") === (0, _moment2.default)(new Date()).format("YYYY-MM-DD");
		};

		_this.isCheckedDiaActual = function (date) {
			return _this.props.timerange.singledays && _this.isDiaActual(date);
		};

		_this.isMoreThanThreeMonths = function (currentRange) {
			return (0, _dateFns.differenceInMonths)(currentRange.endDate, currentRange.startDate) >= 3;
		};

		_this.handleChangeTipus = function (e, _ref) {
			var value = _ref.value;

			var _this$computeTimeRang = _this.computeTimeRange(value),
			    startDate = _this$computeTimeRang.startDate,
			    endDate = _this$computeTimeRang.endDate;

			var startDateFormat = (0, _moment2.default)(startDate).format("YYYY-MM-DD");
			var endDateFormat = (0, _moment2.default)(endDate).format("YYYY-MM-DD");

			_this.setState({ showError: false, myselection: _extends({}, _this.state.myselection, { startDate: startDate, endDate: endDate }) });
			_this.props.updateJsonConfig(["timerange", "calcdatafieldsOptions", "calcdatafieldsCalculs"], [{ tipus: value, timemax: endDateFormat, timemin: startDateFormat }, _extends({}, CONSTANTS.defaultJsonConfig.calcdatafieldsOptions, { datemin: startDateFormat, datemax: endDateFormat }), CONSTANTS.defaultJsonConfig.calcdatafieldsCalculs]);
		};

		_this.handleDismissError = function () {
			return _this.setState({ showError: false });
		};

		_this.state = {
			showError: false,
			extraMsg: "",
			myselection: {
				startDate: new Date(props.timerange.timemin),
				endDate: _this.getInitEndDate(props.timerange.timemax, props.timerange.singledays, props.timerange.dynamic),
				key: "myselection"
			}
		};
		return _this;
	}

	_createClass(PanelSelectRangTemporal, [{
		key: "componentDidMount",


		//toggleCheckedDiaActual = () => this.setState({ checkedDiaActual: !this.state.checkedDiaActual });

		value: function componentDidMount() {
			var _this2 = this;

			if (this.props.data.isCSVFile) {

				_request2.default.get(CONSTANTS.URL_GET_COLUMNS + "/" + this.props.data.databasename + "/time-ranges").then(function (data) {

					//console.info(data);
					if (data && data.max) {

						var range = { "myselection": {} };
						range.myselection.endDate = (0, _moment2.default)(data.max).format("YYYY-MM-DD");
						range.myselection.startDate = (0, _moment2.default)(data.min).format("YYYY-MM-DD");

						_this2.handleSelectRange(range);
						_this2.setState({ extraMsg: range.myselection.startDate + " - " + range.myselection.endDate + " " });
					} else {
						_this2.setState({ extraMsg: "Error per obtenir el rang temporal de CSV" });
					}
				}).catch(function (err) {
					console.info(err);
					_this2.setState({ extraMsg: "Error:" + err });
				});
			} else if (this.props.timerange.tipus === CONSTANTS.CUSTOM && this.props.timerange.timemax !== (0, _moment2.default)(this.state.myselection.endDate).format("YYYY-MM-DD")) {

				this.props.updateJsonConfig("timerange", _extends({}, this.props.timerange, { timemax: (0, _moment2.default)(this.state.myselection.endDate).format("YYYY-MM-DD") }));
			}
		}
	}, {
		key: "computeTimeRange",
		value: function computeTimeRange(value) {

			if (value === "custom") {

				return {
					startDate: (0, _dateFns.subDays)(new Date(), 2),
					endDate: (0, _dateFns.subDays)(new Date(), 1)
				};
			} else {
				var option = CONSTANTS.RANG_TEMPORAL_OPCIONS.find(function (elem) {
					return elem.value === value;
				});

				return {
					startDate: (0, _dateFns.subDays)(new Date(), option.daystosubstractstartdate),
					endDate: (0, _dateFns.subDays)(new Date(), option.daystosubstractenddate)
				};
			}
		}
	}, {
		key: "handleSelectRange",
		value: function handleSelectRange(range) {

			var currentRange = range.myselection;
			var checkedDiaActual = this.isCheckedDiaActual(currentRange.endDate);

			if (this.isMoreThanThreeMonths(currentRange) && !this.props.timerange.singledays) {

				currentRange.startDate = (0, _dateFns.subMonths)(currentRange.endDate, 3);
			}

			this.setState({ myselection: currentRange });

			this.props.updateJsonConfig(["timerange", "calcdatafieldsOptions", "calcdatafieldsCalculs"], [_extends({}, this.props.timerange, { timemax: (0, _moment2.default)(currentRange.endDate).format("YYYY-MM-DD"), timemin: (0, _moment2.default)(currentRange.startDate).format("YYYY-MM-DD"), dynamic: checkedDiaActual }), _extends({}, CONSTANTS.defaultJsonConfig.calcdatafieldsOptions, { granularitat: checkedDiaActual && this.props.timerange.singledays ? CONSTANTS.GRANULARITAT_HORES : CONSTANTS.GRANULARITAT_DIES }), CONSTANTS.defaultJsonConfig.calcdatafieldsCalculs]);
		}
	}, {
		key: "renderSinglesDays",
		value: function renderSinglesDays(doRender) {

			if (!doRender) {
				return _react2.default.createElement(
					"div",
					{ className: _PanelSelectRangTemporal2.default.singleDaysBoxDisabled },
					_react2.default.createElement(
						"p",
						null,
						_react2.default.createElement(
							_semanticUiReact.Label,
							null,
							"Dia 1"
						),
						" DD/MM/yyyy "
					),
					_react2.default.createElement(_semanticUiReact.Divider, null),
					_react2.default.createElement(
						"p",
						null,
						_react2.default.createElement(
							_semanticUiReact.Label,
							null,
							"Dia 2"
						),
						" DD/MM/yyyy "
					),
					_react2.default.createElement(_semanticUiReact.Checkbox, { disabled: true, label: "Dia actual i din\xE0mic", checked: this.props.timerange.dynamic, readOnly: true })
				);
			}

			var timerange = this.props.timerange;


			return _react2.default.createElement(
				"div",
				{ className: _PanelSelectRangTemporal2.default.singleDaysBox },
				_react2.default.createElement(
					"p",
					null,
					_react2.default.createElement(
						_semanticUiReact.Label,
						{ color: "teal" },
						"Dia 1"
					),
					" ",
					(0, _moment2.default)(timerange.timemin).format("DD/MM/YYYY"),
					" "
				),
				_react2.default.createElement(_semanticUiReact.Divider, null),
				_react2.default.createElement(
					"p",
					null,
					_react2.default.createElement(
						_semanticUiReact.Label,
						{ color: "teal" },
						"Dia 2"
					),
					" ",
					(0, _moment2.default)(timerange.timemin).format("DD/MM/YYYY"),
					_react2.default.createElement(_semanticUiReact.Popup, {
						size: "small",
						className: _PanelSelectRangTemporal2.default.myPopUp,
						position: "right center",
						trigger: _react2.default.createElement(_semanticUiReact.Icon, { className: _PanelSelectRangTemporal2.default.iconPopup, fitted: true, circular: true, color: "teal", name: "question" }),
						content: "Si la selecci\xF3 es correspon amb el dia actual, s'habilita 'dia actual din\xE0mic' per defecte" })
				),
				_react2.default.createElement(_semanticUiReact.Checkbox, { disabled: true, label: "Dia actual i din\xE0mic", checked: timerange.dynamic, className: timerange.dynamic ? _PanelSelectRangTemporal2.default.boldText : "", readOnly: true })
			);
		}
	}, {
		key: "renderDateRange",
		value: function renderDateRange() {
			var _this3 = this;

			if (this.props.timerange.tipus === CONSTANTS.CUSTOM) {

				return _react2.default.createElement(
					"span",
					null,
					_react2.default.createElement(
						_semanticUiReact.Message,
						{ compact: true, info: true },
						_react2.default.createElement(
							"p",
							null,
							_react2.default.createElement(_semanticUiReact.Icon, { name: "info" }),
							" Per seleccionar ",
							_react2.default.createElement(
								"b",
								null,
								"1 \xFAnic dia"
							),
							" marca l'inici i el final del rang al mateix dia del calendari."
						),
						_react2.default.createElement(
							"p",
							null,
							_react2.default.createElement(_semanticUiReact.Icon, { name: "info" }),
							" Per seleccionar ",
							_react2.default.createElement(
								"b",
								null,
								"2 dies (SENSE RANG)"
							),
							" selecciona'ls com si fos un rang i habilita la opci\xF3 ",
							_react2.default.createElement(
								"i",
								null,
								"Selecci\xF3 de 2 dies concrets"
							),
							"."
						),
						_react2.default.createElement(
							"p",
							null,
							_react2.default.createElement(_semanticUiReact.Icon, { name: "info" }),
							" El m\xE0xim rang temporal perm\xE8s \xE9s de ",
							_react2.default.createElement(
								"b",
								null,
								"3 mesos"
							),
							"."
						)
					),
					_react2.default.createElement(
						"div",
						{ className: _PanelSelectRangTemporal2.default.containerCheckDinamic },
						_react2.default.createElement(_semanticUiReact.Checkbox, {
							toggle: true,
							checked: this.props.timerange.singledays,
							onChange: function onChange(e, data) {
								return _this3.handleChangeToggleSingleDays(data.checked);
							},
							label: "Selecció de 2 dies concrets (actual inclòs)",
							className: this.props.timerange.singledays ? _PanelSelectRangTemporal2.default.boldText : ""
						}),
						this.renderSinglesDays(this.props.timerange.singledays)
					),
					_react2.default.createElement(_reactDateRange.DateRange, {
						maxDate: (0, _dateFns.subDays)(new Date(), this.props.timerange.singledays ? 0 : 1),
						color: "#00b5ad",
						rangeColors: ["#00b5ad", "#00b5ad"],
						className: _PanelSelectRangTemporal2.default.previewArea,
						locale: _locale.ca,
						direction: "horizontal",
						months: 2,
						ranges: [this.state.myselection],
						onChange: function onChange(range) {
							return _this3.handleSelectRange(range);
						},
						moveRangeOnFirstSelection: false,
						showSelectionPreview: true
					})
				);
			}
		}
	}, {
		key: "renderSelect",
		value: function renderSelect() {

			if (this.props.data.isCSVFile) {

				return _react2.default.createElement(_semanticUiReact.Message, {
					info: true,
					icon: "info",
					header: "No cal seleccionar rang temporal....",
					content: "Si has pujat un CSV es far\xE0 servir el rang temporal definit al fitxer. " + this.state.extraMsg
				});
			}

			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_semanticUiReact.Select, {
					placeholder: "Selecciona un rang",
					options: CONSTANTS.RANG_TEMPORAL_OPCIONS,
					onChange: this.handleChangeTipus.bind(this),
					defaultValue: this.props.timerange.tipus
				})
			);
		}
	}, {
		key: "handleChangeToggle",
		value: function handleChangeToggle(value, propName) {
			this.props.updateJsonConfig("timerange", _extends({}, this.props.timerange, _defineProperty({}, propName, value)));
		}
	}, {
		key: "handleChangeToggleSingleDays",
		value: function handleChangeToggleSingleDays(checked) {

			if (!checked) {

				var newEndDate = this.isDiaActual(this.props.timerange.timemax) ? (0, _dateFns.subDays)(new Date(), 1) : this.props.timerange.timemax;
				var newStartDate = this.isMoreThanThreeMonths(_extends({}, this.state.myselection, { endDate: newEndDate })) ? (0, _dateFns.subMonths)(newEndDate, 3) : this.state.myselection.startDate;

				this.setState({ myselection: _extends({}, this.state.myselection, { startDate: newStartDate, endDate: newEndDate }) });
				this.props.updateJsonConfig("timerange", _extends({}, this.props.timerange, {
					timemin: (0, _moment2.default)(newStartDate).format("YYYY-MM-DD"),
					timemax: (0, _moment2.default)(newEndDate).format("YYYY-MM-DD"),
					singledays: checked
				}));
			} else {

				this.handleChangeToggle(checked, "singledays");
			}
		}
	}, {
		key: "renderCheckDinamic",
		value: function renderCheckDinamic() {
			var _this4 = this;

			if (!this.props.isCSVFile && (this.props.timerange.tipus === CONSTANTS.TODAY || this.props.timerange.tipus === CONSTANTS.SETMANA || this.props.timerange.tipus === CONSTANTS.QUINZENA)) {
				return _react2.default.createElement(
					"div",
					{ className: _PanelSelectRangTemporal2.default.containerCheckDinamic },
					_react2.default.createElement(_semanticUiReact.Checkbox, {
						toggle: true,
						checked: this.props.timerange.dynamic,
						onChange: function onChange(e, data) {
							return _this4.handleChangeToggle(data.checked, "dynamic");
						},
						label: "Dades din\xE0miques"
					}),
					_react2.default.createElement(
						_semanticUiReact.Label,
						{ basic: true, color: "teal", pointing: "left" },
						_react2.default.createElement(_semanticUiReact.Icon, { name: "info" }),
						" Sempre es carregaran les dades de la darrera setmana o la darrera quinzena a comptar des d'ahir, o del dia en curs."
					)
				);
			}
		}
	}, {
		key: "renderMessageError",
		value: function renderMessageError() {

			if (this.state.showError) {
				var message = this.isSingleCurrentDay() ? "Selecciona la opció 'Dia actual' del desplegable per treballar amb un únic dia corresponent a avui" : "Si us plau, selecciona un rang temporal del desplegable per continuar";
				return _react2.default.createElement(_semanticUiReact.Message, { negative: true, icon: "warning sign", onDismiss: this.handleDismissError, header: "Error", content: message });
			}
		}
	}, {
		key: "isSingleCurrentDay",
		value: function isSingleCurrentDay() {
			var _props$timerange = this.props.timerange,
			    timemax = _props$timerange.timemax,
			    timemin = _props$timerange.timemin,
			    tipus = _props$timerange.tipus;

			return timemax === timemin && tipus !== CONSTANTS.TODAY && tipus !== CONSTANTS.LATEST && this.isDiaActual(timemax);
		}
	}, {
		key: "isValid",
		value: function isValid() {

			var isValid = this.props.data.isCSVFile || this.props.timerange.tipus !== "" && !this.isSingleCurrentDay();
			this.setState({ showError: !isValid });

			return isValid;
		}
	}, {
		key: "getJsonconfigState",
		value: function getJsonconfigState() {
			return null;
		}
	}, {
		key: "render",
		value: function render() {

			return _react2.default.createElement(
				_semanticUiReact.Container,
				{ fluid: true, textAlign: "justified" },
				_react2.default.createElement(
					_semanticUiReact.Header,
					{ as: "h3" },
					CONSTANTS.STEPS[this.props.myStep].description
				),
				this.renderMessageError(),
				_react2.default.createElement(
					"div",
					{ className: _PanelSelectRangTemporal2.default.containerDinamic },
					this.renderSelect(),
					this.renderCheckDinamic()
				),
				_react2.default.createElement(
					"div",
					{ className: _PanelSelectRangTemporal2.default.containerDaterange },
					this.renderDateRange()
				)
			);
		}
	}]);

	return PanelSelectRangTemporal;
}(_react.Component);

exports.default = PanelSelectRangTemporal;


PanelSelectRangTemporal.propTypes = {
	timerange: _propTypes2.default.object,
	data: _propTypes2.default.object,
	myStep: _propTypes2.default.number,
	updateJsonConfig: _propTypes2.default.func,
	isCSVFile: _propTypes2.default.bool
};
